import React, { useMemo } from 'react';
import { translate } from '../../../services/translate';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../../../components/FormDropDownPicker';
import FilterBadgeSearchList, { FilterListItem } from './FilterBadgeSearchList';

type Props = {
    single?: boolean;
    removeManual?: boolean;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value: (TriggerType | 'manual')[];
    setValue: React.Dispatch<React.SetStateAction<(TriggerType | 'manual')[]>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function TypeDropdown({ value, setValue, single, removeManual = false, form, fieldName }: Props) {
    const triggerTypes: (TriggerType | 'manual')[] = useMemo(() => [
        'face_detected',
        'missing_face_detected',
        'plate_detected',
        'plate_detected_by_mobile_agent',
        'plate_detected_by_citizen_app',
        'irregular_vehicle',
        'clone_suspect',
        'illegal_debris',
        'area_invasion',
        'mp_plate_detected',
        'mp_mobile_agent_plate_detected',
        'mp_face_detected',
        'alarm_center',
        'manual',
        'guardian_app',
        'school_app',
        'sigrc',
        'cortex_plate_detected',
        'scenechangedetection'
    ].filter(triggerType => !(removeManual && triggerType === 'manual')) as (TriggerType | 'manual')[], [removeManual]);

    const items: FilterListItem<TriggerType | 'manual'>[] = useMemo(() =>
        triggerTypes.map(triggerType => ({
            label: translate(triggerType),
            value: triggerType
        })), [triggerTypes]);

    if (form && fieldName) {
        return <FormDropDownPicker
            items={items}
            fieldName={fieldName}
            form={form}
            multiple={true}
            mode='BADGE'
            zIndex={1}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return (
            <FilterBadgeSearchList
                items={items}
                value={value}
                setValue={(newValue) => {
                    if (single && Array.isArray(newValue) && newValue.length > 1) {
                        setValue([newValue[newValue.length - 1]]);
                    } else {
                        setValue(newValue);
                    }
                }}
            />
        );
    }

    return null;
}

export default TypeDropdown;
